import { Component, Input, OnInit } from "@angular/core";


@Component({
  selector: 'app-chip-siga-status',
  templateUrl: './chip-siga-status.component.html',
  styleUrls: ['./chip-siga-status.component.css']
})
export class ChipSigaStatusComponent implements OnInit {

  constructor() { }

  @Input() public status: string;

  ngOnInit(): void {
  }
}
